import React from "react";
import { useSelector } from "react-redux";
import { InsertChart as InsertChartIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetVersionBomQuery } from "fond/api";
import { Project, Store } from "fond/types";
import { BlockSpinner, Message, Modal } from "fond/widgets";

import BomContent from "./BomContent";

interface InteractiveBomModalProps {
  project: Project;
  onClose(): void;
}

const InteractiveBomModal: React.FC<InteractiveBomModalProps> = ({ project, onClose }: InteractiveBomModalProps) => {
  const versionId = useSelector((state: Store) => state.project.versionId);
  const { data: bom, isLoading } = useGetVersionBomQuery(versionId ?? skipToken);

  const getContent = () => {
    if (isLoading) {
      return <BlockSpinner />;
    }
    if (!bom) {
      return <Message type="warning">The BOM is not available.</Message>;
    }
    return <BomContent bom={bom} project={project} />;
  };

  return (
    <Modal
      fullscreen
      showClose
      open
      onClose={onClose}
      variant="primary"
      header="Interactive bill of materials"
      headerSubtitle="MATERIALS & COSTS"
      headerIcon={<InsertChartIcon />}
      data-testid="interactive-bom-modal"
      DialogContentProps={{ style: { display: "flex", flexDirection: "column", minHeight: 0 } }}
      content={getContent()}
      actions={
        <Button data-testid="interactive-bom-modal-close-button" onClick={onClose}>
          Close
        </Button>
      }
    />
  );
};

export default InteractiveBomModal;
